import { BasicLayout } from "@stories/layout/BasicLayout";
import * as RouteHelper from "@utils/routes";
import { LoginView } from "@views/Pages/Authenticate/LoginView";
import { SignUpView } from "@views/Pages/Authenticate/SignUpView";
import { ProjectView } from "@views/Pages/Contractor/ProjectView/ProjectView";
import { DemoView } from "@views/Pages/Home/DemoView";
import { HomeView } from "@views/Pages/Home/HomeView";
import { ListProjectsView } from "@views/Pages/ListProjectsView/ListProjectsView";
import { UsersView } from "@views/Pages/UsersView/UsersView";
import { DashboardView as ContractorDashboardView } from "@views/Pages/Contractor/DashboardView/DashboardView";

import { PackagesView } from "@views/Pages/Contractor/PackagesView/PackagesView";
import { AnalyticsHoursView } from "@views/Pages/Contractor/AnalyticsHoursView/AnalyticsHoursView";
import { LabourHoursView } from "@views/Pages/Contractor/LabourHoursView/LabourHoursView";
import { SocialProcurementView } from "@views/Pages/Contractor/SocialProcurementView/SocialProcurementView";
import { DirectoryView } from "@views/Pages/DirectoryView/DirectoryView";
import { NoMenuLayout } from "@stories/layout/NoMenuLayout";
import { AccountView } from "@views/Pages/Account/AccountView";
import { NO_ORGANISATION_ID, ProfileLineItem, ProfileStatus } from "@interfaces/profile";
import { ReportView } from "@views/Pages/Contractor/ReportView/ReportView";

import { NoLayout } from "@stories/layout/NoLayout";
import { VerifyView } from "@views/Pages/Authenticate/VerifyView";
import { AnalyticsSpendView } from "@views/Pages/Contractor/AnalyticsSpendView/AnalyticsSpendView";
import MainDashboardLayout from "@stories/layout/MainLayout";
import { EmployeesView } from "@views/Pages/Contractor/EmployeesView/EmployeesView";
import { ContractorPackageView } from "@views/Pages/Contractor/ContractorPackageView/ContractorPackageView";
import { PoliciesView } from "@views/Pages/Contractor/PoliciesView/PoliciesView";

export interface RouteInfo {
  index?: boolean;
  path: string;
  component: React.FC<any>;
  layout: React.FC<any>;
}

const routesUnauthenticated: RouteInfo[] = [
  {
    index: true,
    path: RouteHelper.home,
    component: HomeView,
    layout: BasicLayout,
  },
  {
    path: RouteHelper.signUp,
    component: SignUpView,
    layout: BasicLayout,
  },
  {
    path: RouteHelper.login,
    component: LoginView,
    layout: BasicLayout,
  },
  {
    path: RouteHelper.verify,
    component: VerifyView,
    layout: NoLayout,
  },
  {
    path: RouteHelper.demo,
    component: DemoView,
    layout: BasicLayout,
  },
];

const routesAuthenticatedNoProfile: RouteInfo[] = [
  {
    index: true,
    path: RouteHelper.profile,
    component: AccountView,
    layout: NoMenuLayout,
  },
];

const routesAuthenticated: RouteInfo[] = [
  {
    index: true,
    path: RouteHelper.listProjects,
    component: ListProjectsView,
    layout: NoMenuLayout,
  },
  {
    path: RouteHelper.project(":projectId?"),
    component: ProjectView,
    layout: NoMenuLayout,
  },
  {
    path: RouteHelper.profile,
    component: AccountView,
    layout: NoMenuLayout,
  },
  {
    index: true,
    path: RouteHelper.users,
    component: UsersView,
    layout: NoMenuLayout,
  },
  {
    path: RouteHelper.contractorDashboard(":projectId"),
    component: ContractorDashboardView,
    layout: MainDashboardLayout,
  },
  {
    path: RouteHelper.contractorDashboardMonthly(":projectId"),
    component: ContractorDashboardView,
    layout: MainDashboardLayout,
  },
  {
    path: RouteHelper.packages(":projectId"),
    component: PackagesView,
    layout: MainDashboardLayout,
  },
  {
    path: RouteHelper.contractorPackage(":projectId", ":packageId"),
    component: ContractorPackageView,
    layout: MainDashboardLayout,
  },
  {
    path: RouteHelper.contractorReports(":projectId"),
    component: ReportView,
    layout: MainDashboardLayout,
  },
  {
    path: RouteHelper.analyticsLabourHours(":projectId"),
    component: AnalyticsHoursView,
    layout: MainDashboardLayout,
  },
  {
    path: RouteHelper.analyticsSpend(":projectId"),
    component: AnalyticsSpendView,
    layout: MainDashboardLayout,
  },
  {
    path: RouteHelper.labourHours(":projectId", ":reportId"),
    component: LabourHoursView,
    layout: MainDashboardLayout,
  },
  {
    path: RouteHelper.socialProcurement(":projectId", ":reportId"),
    component: SocialProcurementView,
    layout: MainDashboardLayout,
  },
  {
    path: RouteHelper.directory(":projectId"),
    component: DirectoryView,
    layout: MainDashboardLayout,
  },
  {
    path: RouteHelper.contractorDashboard(":projectId"),
    component: ContractorDashboardView,
    layout: MainDashboardLayout,
  },
  {
    path: RouteHelper.contractorEmployees(":projectId"),
    component: EmployeesView,
    layout: MainDashboardLayout,
  },
  {
    path: RouteHelper.contractorPolicies(":projectId"),
    component: PoliciesView,
    layout: MainDashboardLayout,
  },
];

export const getRoutes = (loggedIn: boolean, profile: ProfileLineItem | null) => {
  if (loggedIn && profile && profile.status === ProfileStatus.Invited) {
    return routesAuthenticatedNoProfile;
  }
  if (profile && profile.organisationId === NO_ORGANISATION_ID) {
    return routesAuthenticatedNoProfile;
  }
  if (loggedIn) {
    return routesAuthenticated;
  }

  return routesUnauthenticated;
};
